import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_PATH } from "../../environment";

const DASHBOARD_BASE_URL = `${API_BASE_PATH}/register/all-dashboard`;

export type EmployeeTableData = {
  key: string;
  EmpId: string;
  Name: string;
  Email: string;
  Phone: string;
  Designation: string;
  JoiningDate: string;
  Status: string;
  Image: string;
  CurrentRole: string;
};

const useDashTable = (token: string | null) => {
  const [data, setData] = useState<EmployeeTableData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchData = async () => {
    if (!token) return; // don't call API if token is missing
    setIsLoading(true);
    try {
      const res = await axios.get(DASHBOARD_BASE_URL, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const transformed: EmployeeTableData[] = res.data.map((item: any) => ({
        key: item.employee_id,
        EmpId: item.employee_id,
        Name: item.username,
        Email: item.email,
        Phone: item.phone,
        Designation: item.designation_name || "N/A",
        JoiningDate: item.join_date || "-",
        Status:
          item.employee_status?.toLowerCase() === "active"
            ? "Active"
            : "Inactive",
        Image: item.photo_url || "default.jpg",
        CurrentRole: item.designation_name || "N/A",
      }));

      setData(transformed);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [token]);

  return {
    data,
    isLoading,
    refetch: fetchData,
  };
};

export default useDashTable;
